import { useRef } from 'react';

const uninitialized = Symbol();
function useSingleton(factory) {
  const ref = useRef(uninitialized);
  if (ref.current === uninitialized) {
    ref.current = factory();
  }
  return ref.current;
}

export { useSingleton };
//# sourceMappingURL=singleton.js.map
